import React, { Component } from "react";
import { withRouter } from "react-router";

import "./index.css";

import { getRegPath, OUTLINED_LOGO, SWIPE_LOGO } from "../../../constants";
import { saveRole } from "../../../utils/localStorage";

const slider = React.createRef();
const container = React.createRef();
const isTouchDevice = "ontouchstart" in document.documentElement;

class StepOne extends Component {
  componentDidMount() {
    if (isTouchDevice) {
      document.addEventListener("touchmove", this.onDrag);
      document.addEventListener("touchend", this.stopDrag);
    } else {
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
    }
    this.containerHeight = navigator.vendor.includes("Apple")
      ? (container.current.clientHeight + 135) / 2
      : container.current.clientHeight + 135;
  }
  onDrag = e => {
    if (this.unmounted) return;
    if (this.isDragging) {
      if (isTouchDevice) {
        this.sliderLeft = Math.min(
          Math.max(
            -(this.containerHeight / 2) - this.containerHeight / 2 - 115,
            e.touches[0].clientY - this.startY
          ),
          this.containerHeight + this.containerHeight / 2 + 20
        );
      } else {
        this.sliderLeft = Math.min(
          Math.max(
            -(this.containerHeight / 2) - this.containerHeight / 2,
            e.clientY - this.startY
          ),
          this.containerHeight
        );
      }
      this.updateSliderStyle();
    }
  };

  updateSliderStyle = () => {
    if (this.unmounted) return;
    slider.current.style.marginTop =
      ((this.sliderLeft >= 130
        ? this.containerHeight && (this.sliderLeft = this.containerHeight)
        : 0) ||
        (this.sliderLeft <= -150
          ? -this.containerHeight && (this.sliderLeft = -this.containerHeight)
          : 0) ||
        (this.sliderLeft === 0
          ? window.innerHeight / 2 / 100
          : this.sliderLeft)) + "px";
  };

  stopDrag = () => {
    if (this.unmounted) return;
    if (this.isDragging) {
      this.isDragging = false;
      if (this.sliderLeft === this.containerHeight) {
        this.sliderLeft = this.containerHeight;
        saveRole("PATIENT");
        this.onSuccess();
      } else if (
        this.sliderLeft < 0 &&
        this.sliderLeft === -this.containerHeight
      ) {
        this.sliderLeft = -this.containerHeight;
        saveRole("PHYSICIAN");
        this.onSuccess();
      } else {
        this.sliderLeft = 0;
        if (this.props.onFailure) {
          this.props.onFailure();
        }
      }
      this.updateSliderStyle();
    }
  };

  startDrag = e => {
    if (this.unmounted) return;
    this.isDragging = true;
    if (isTouchDevice) {
      this.startY = e.touches[0].clientY;
    } else {
      this.startY = e.clientY;
    }
  };

  onSuccess = () => {
    const auto_skip_tour = localStorage.getItem("auto_skip_tour");
    if(auto_skip_tour == "true"){
      // When there auto skip tour key set true then skip step tour.
      this.props.history.push(getRegPath("/signin"));
      return null;
    }
    // Or else redirect user to the tour step.
    container.current.style.width = container.current.clientHeight + "px";
    this.props.history.push(getRegPath("/step2"));
  };

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    return (
      <div
        style={{
          margin: "auto",
          marginTop: "13%",
        }}
        className="userSwipeButton text-center d-table align-items-center"
      >
        <div className="mb-n5">
          <p className="drag-text">
            Drag the logo up if you are a <br />
            <span className="font-weight-bold change-primary-color">
              {" "}
              Doctor
            </span>
          </p>
          <img src={OUTLINED_LOGO} alt="" className="mb-2 ml-2" />
          <div className="arrow_up">&nbsp;</div>
          <div className="arrow_up">&nbsp;</div>
          <div className="arrow_up">&nbsp;</div>
        </div>
        <div
          ref={container}
          style={{
            width: 200,
            height: 200,
            marginLeft: "35%",
          }}
          className="d-flex flex-wrap align-items-center"
        >
          <div
            className="slider"
            ref={slider}
            onMouseDown={this.startDrag}
            onTouchStart={this.startDrag}
          >
            <span className="sliderCircle"></span>
            <img src={SWIPE_LOGO} alt="" width={75} height={75} />
          </div>
        </div>
        <div className="mt-n5">
          <div className="arrow_down">&nbsp;</div>
          <div className="arrow_down">&nbsp;</div>
          <div className="arrow_down">&nbsp;</div>

          <img src={OUTLINED_LOGO} alt="" className="mt-1 ml-2" />
          <p className="drag-text mt-3">
            Drag the logo down if you are a<br />
            <span className="font-weight-bold change-primary-color">
              {" "}
              Patient
            </span>
          </p>
        </div>
      </div>
    );
  }
}

export default withRouter(StepOne);
